// DraggableCard wrapper
import React from "react";

interface StaticCardProps {
    children?: any
    X?: number;
    Y?: number;
    rotation?: number;
    onMouseEnter?: Function;
    onMouseLeave?: Function;
}

export default function StaticCard({
    children,
    X = 0,
    Y = 0,
    rotation = 0,
    onMouseEnter,
    onMouseLeave
}: StaticCardProps) {

    return (
        <div
            style={{
                position: "absolute",
                left: X,
                top: Y,
                transform: `rotate(${rotation}deg)`,
            }}
            onMouseEnter={() => { onMouseEnter && onMouseEnter() }}
            onMouseLeave={() => { onMouseLeave && onMouseLeave() }}
        >
            {children}
        </div>
    );
}
